export default "__VITE_ASSET__eo0r0zXJ__"